var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("🌍 Nuestros visitantes")]),_c('v-card-text',[_c('div',{staticStyle:{"height":"500px"},attrs:{"id":"map"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }